import { useTranslation } from "react-i18next";
import AppDialog from "../../../components/AppDialog/AppDialog";
import CreateUserForm from "./CreateUserForm";

export default function CreateUserDialog({ open, onClose, onSuccess }) {
  const { t } = useTranslation();

  return (
    <AppDialog open={open} onClose={onClose} title={t("createuser.title")} maxWidth="md" fullWidth>
      <CreateUserForm onCancel={onClose} onSuccess={onSuccess} />
    </AppDialog>
  );
}
